import CityServiceTemplate from "@/components/CityServiceTemplate";
import fairOaksRanchHero from "@/assets/cities/fair-oaks-ranch-hero.jpg";

const CarServiceFairOaksRanch = () => {
  return (
    <CityServiceTemplate
      cityName="Fair Oaks Ranch"
      cityDescription="Executive black car service for the Fair Oaks Ranch community. Professional chauffeur service for business travel, airport transfers, and special occasions."
      metaDescription="Luxury car service in Fair Oaks Ranch, TX. Executive transportation, airport service & event chauffeur. Book today!"
      canonicalPath="/fair-oaks-ranch-car-service"
      heroImage={fairOaksRanchHero}
      additionalContent="Fair Oaks Ranch residents expect the best, and Rick's Black Car Service delivers. Our professional chauffeurs provide discreet, reliable transportation for business meetings, airport transfers, social events, and everyday travel needs throughout the San Antonio area."
      coordinates={{
        latitude: 29.7449,
        longitude: -98.6447
      }}
      serviceRadius="35 miles"
      featuredPricing={{
        route: "Fair Oaks Ranch ↔ SAT Airport",
        price: "$195",
        note: "All-inclusive flat rate (includes 20% gratuity)"
      }}
      cityReviews={[
        {
          author: "Robert Williams",
          rating: 5,
          date: "2024-12-01",
          text: "Rick has been our family's preferred chauffeur for years in Fair Oaks Ranch. Whether it's business trips downtown or airport runs, his service is consistently exceptional. The epitome of professionalism."
        },
        {
          author: "Patricia Martinez",
          rating: 5,
          date: "2024-10-12",
          text: "We used Rick for our daughter's prom in Fair Oaks Ranch and he made the evening extra special. Punctual, courteous, and the luxury vehicle was stunning. Thank you Rick!"
        }
      ]}
    />
  );
};

export default CarServiceFairOaksRanch;
